import apiURL from "./apiURL";
// const apiURL = "http://localhost:3000"
// const orgId = window.location.pathname == '/xero/callback/' ? window.localStorage.getItem('organisation') : window.location.pathname.split('/')[2];

// types of action
const Types = {
	OVERTIME_UPDATE_LIST: "OVERTIME_UPDATE_LIST",
	OVERTIME_ADD: "OVERTIME_ADD",
	OVERTIME_CLEAR: "OVERTIME_CLEAR",
	OVERTIME_ADVISOR_ADD: "OVERTIME_ADVISOR_ADD",
	OVERTIME_UPDATE_FIELD: "OVERTIME_UPDATE_FIELD",
	OVERTIME_ADVISOR_UPDATE_FIELD: "OVERTIME_ADVISOR_UPDATE_FIELD",
	OVERTIME_CHECKED_RATE: "OVERTIME_CHECKED_RATE",
	OVERTIME_APPLY_TEMPLATE: "OVERTIME_APPLY_TEMPLATE",
};

const updateSetting = (id, field, newValue, newCompany) => ({
	type: Types.OVERTIME_UPDATE_FIELD,
	id,
	field,
	newValue,
	newCompany,
});

const updateAdvisorSetting = (id, field, newValue) => ({
	type: Types.OVERTIME_ADVISOR_UPDATE_FIELD,
	id,
	field,
	newValue,
});

const checkedOvertime = (rateChecked, rate) => ({
	type: Types.OVERTIME_CHECKED_RATE,
	rateChecked,
	rate,
});

const addOvertime = (newCompany, id) => ({
	type: Types.OVERTIME_ADD,
	newCompany,
	id,
});

const clearOvertime = (newCompany) => ({
	type: Types.OVERTIME_CLEAR,
	newCompany,
});

const addAdvisorOvertime = () => ({
	type: Types.OVERTIME_ADVISOR_ADD,
});

const overtimeUpdateList = (response) => ({
	type: Types.OVERTIME_UPDATE_LIST,
	payload: response,
});

const overtimeApplyTemplate = (template) => ({
	type: Types.OVERTIME_APPLY_TEMPLATE,
	template,
});

const overtimeGetList = () => {
	return (dispatch, getState) => {
		fetch(apiURL + `/settings/overtime`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				console.log("entity data", data);
				dispatch(overtimeUpdateList(data));
			});
	};
};

/*const selectTrackingCategory = trackingCategory => ({
  type: Types.SELECT_TRACKING_CATEGORY,
  trackingCategory: trackingCategory
});

const selectYear = year => ({
  type: Types.SELECT_YEAR,
  year
});

const updateFacilities = response => ({
  type: Types.GET_FACILITIES,
  payload: response
});

const getFacilities = () => {
  return (dispatch, getState) => {

    fetch(apiURL + `/my/facilities` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Organisation': getState().currentOrganisation,
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      dispatch(updateFacilities(data))
    })
  }
}*/

const Actions = {
	overtimeGetList,
	addOvertime,
	clearOvertime,
	addAdvisorOvertime,
	updateSetting,
	updateAdvisorSetting,
	checkedOvertime,
	overtimeApplyTemplate,
};

// exports = {
//   Types,
//   Actions
// }

export { Actions, Types };

// exports.Types = Types
// exports.Actions = Actions
